// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* eslint-disable css/no-invalid-properties */
/* Weather hero: main weather display with condition, temperature, location */

.weather-hero__info {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.weather-hero__header {
  display: flex;
  align-items: center;
}

.weather-hero__icon {
  width: 127px;
  height: 127px;
  border-radius: 50%;
}

.weather-hero__condition {
  font-size: 5rem;
  max-width: 15ch;
  line-height: 1.1;
  margin: 0;
}

.weather-hero__description {
  font-size: 1.2rem;
  max-width: 45ch;
}

.weather-hero__temperature {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 2rem;
  font-family: var(--font-jakarta);
  font-variant-numeric: tabular-nums;
}

.weather-hero__temperature-current {
  font-size: 6rem;
  font-weight: 800;
  margin: 0;
}

.weather-hero__temperature-range dl {
  font-weight: 600;
  margin: 0.3rem;
  display: flex;
  padding: 0.5rem;
  min-width: 100px;
  justify-content: space-between;
  border-radius: 20px;
}

.weather-hero__location {
  font-family: var(--font-jakarta);
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.weather-hero__time {
  font-family: var(--font-jakarta);
  font-weight: 600;
}

.weather-hero__location-icon {
  width: 25px;
  height: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/weatherHero.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,6EAA6E;;AAE7E;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* eslint-disable css/no-invalid-properties */\n/* Weather hero: main weather display with condition, temperature, location */\n\n.weather-hero__info {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.weather-hero__header {\n  display: flex;\n  align-items: center;\n}\n\n.weather-hero__icon {\n  width: 127px;\n  height: 127px;\n  border-radius: 50%;\n}\n\n.weather-hero__condition {\n  font-size: 5rem;\n  max-width: 15ch;\n  line-height: 1.1;\n  margin: 0;\n}\n\n.weather-hero__description {\n  font-size: 1.2rem;\n  max-width: 45ch;\n}\n\n.weather-hero__temperature {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  font-family: var(--font-jakarta);\n  font-variant-numeric: tabular-nums;\n}\n\n.weather-hero__temperature-current {\n  font-size: 6rem;\n  font-weight: 800;\n  margin: 0;\n}\n\n.weather-hero__temperature-range dl {\n  font-weight: 600;\n  margin: 0.3rem;\n  display: flex;\n  padding: 0.5rem;\n  min-width: 100px;\n  justify-content: space-between;\n  border-radius: 20px;\n}\n\n.weather-hero__location {\n  font-family: var(--font-jakarta);\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.weather-hero__time {\n  font-family: var(--font-jakarta);\n  font-weight: 600;\n}\n\n.weather-hero__location-icon {\n  width: 25px;\n  height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
